import { getAPI } from "./base";

export async function generatePowerPoint(data) {
  try {
    const api = getAPI();
    const response = await api.post("/powerpoint/generate_powerpoint", data, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob", // Ensure the response is treated as blob
    });
    return response;
  } catch (error) {
    console.error("Error posting powerpoint data: ", error);
    throw error;
  }
}
